import React, { useState, useEffect } from 'react';

import { Card } from '@material-ui/core';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
// import Badge from '@material-ui/core/Badge';

import { Link } from 'react-router-dom';
// import * as IoIcons from 'react-icons/io';
import Styles, { Fab, LineMenuHome } from '../Styles'

import {
	api_bd,
	api_glpi
} from '../../services/Api'

import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import userState, { profileData } from '../../atoms/user.atom'
import customerData from '../../atoms/customers.atom'
import clientDetails from '../../atoms/client_details.atom'
// import userTickets from '../../atoms/tickets.atom'
import navigationState from '../../atoms/navigate_state.atom'

import ListTickets from '../Tables/Tickets_new.js'

import '../Navbar/Navbar.css';

import AvisoHome from '../../assets/aviso_home.jpeg'

import CadClient from '../../pages/CadClient.js';
import FormDataClient from '../Forms/FormDataClient.js';

import ViteModal from '../ViteModal/index.js';
import { modalDataState } from '../../atoms/appState.js';

// import LogoColor from '../../assets/logo_big_intec.png'
// import Modal from '../Modal'
// import FormDataUser from '../Forms/FormDataUser'
// import ModalTikets from '../ModalTickets'

const { backend_files_address } = require('../../config.json')

function CustomerList(props) {
	const styles = Styles();

	const [sgi_user, set_sgi_user] = useRecoilState(userState)

	const profile_data = useRecoilValue(profileData)

	const set_client_details = useSetRecoilState(clientDetails)

	const [data_home, set_data_home] = useRecoilState(customerData)

	const [data_home2, set_data_home2] = useState([])

	const [navigation, set_navigation] = useRecoilState(navigationState)

	const [glpi_level, set_glpi_level] = useState('')

	const [device_height, set_device_height] = useState(null)

	const [showDisabledCustomers, setShowDisabledCustomers] = useState(false)

	const [loading_message, set_loading_message] = useState('Carregando informações, por favor aguarde.....')

	const [modalData, setModalData] = useRecoilState(modalDataState)

	// const [show_modal, set_show_modal] = useState(false)
	// const [show_loading, set_show_loading] = useState(true)
	// const [show_modal_tickets, set_show_modal_tickets] = useState(false)
	// const [device_width, set_device_width] = useState(null)
	// const [tickets, set_tickets] = useRecoilState(userTickets)
	// const [glpi_user_name, set_glpi_user_name] = useState('')
	// const [glpi_user, set_glpi_user] = useState('')
	// const [user_sgi, set_user_sgi] = useState(null)


	useEffect(() => {
		set_client_details({})
		// const dw = document.documentElement.clientWidth
		const dh = document.documentElement.clientHeight
		// set_device_width(dw)
		set_device_height(dh)
	}, [])


	useEffect(() => {
		// console.log('Page HOME', profile_data, sgi_user)
		// console.log('ProfileData', profile_data)
		// console.log('UserData', sgi_user)
		set_glpi_level(profile_data.nivel)
	}, [sgi_user])


	// useEffect(() => {
	// 	(async () => {
	// 		// const data = await getUserData()
	// 		// set_user_sgi(data.user_sgi)
	// 		// set_glpi_user(data.glpiname)
	// 		// set_glpi_user_name(data.glpifirstname)


	// 	})()
	// }, [glpi_level])



	//get inactive customers


	useEffect(() => {
		if (showDisabledCustomers === true) {
			api_bd.get(`/customers?state=Inativo`).then(resp => {
				if (resp.data.length > 0) {
					// console.log('Inative customers',resp.data)
					const ordered_data = resp.data.sort((a, b) => a.nome.localeCompare(b.nome))
					set_data_home2(ordered_data)
				} else {
					// console.log('dados 2')
				}
			})
		}
	}, [showDisabledCustomers])

	const loadClients = (setLoading) => {
		return new Promise(async (resolve, reject) => {
			// set_loading_message('Carregando informações, por favor aguarde.....')
			setLoading('Carregando informações, por favor aguarde.....')
			if (profile_data.nivel === 'Cliente') {
				await api_bd.get(`/customers/glpiuser/${profile_data.username}`).then(response => {
					if (response.data.length > 0) {
						// set_data_home(dados.data)
						resolve(response.data)
					} else {
						// set_loading_message('Nenhuna Informação Cadastrada')
						setLoading('Nenhuna Informação Cadastrada')
						resolve([])
					}
				}).catch((err) => {
					console.error('Error loading clients:', err)
					setLoading('Erro ao carregar clientes')
					reject()
				})

			} else if (profile_data.nivel === 'Cliente-Admin') {
				// console.log(`/customers/cliente-admin/${profile_data.id}`)
				await api_bd.get(`/customers/cliente-admin/${profile_data.id}`).then(response => {
					if (response.data.length > 0) {
						const ordered_data = response.data ? response.data.sort((a, b) => a.nome.localeCompare(b.nome)) : []
						// set_data_home(dados.data)
						// set_data_home(ordered_data)
						resolve(ordered_data)
					} else {
						// set_loading_message('Nenhuna Informação Cadastrada')
						setLoading('Nenhuna Informação Cadastrada')
						resolve([])
					}
				}).catch((err) => {
					console.error('Error loading clients:', err)
					setLoading('Erro ao carregar clientes')
					reject()
				})


			} else if (profile_data.nivel.match(/Super|Técnico/i)) {
				await api_bd.get(`/customers`).then(response => {
					if (response.data.length > 0) {
						const ordered_data = response.data ? response.data.sort((a, b) => a.nome.localeCompare(b.nome)) : []
						// set_data_home(dados.data)
						// set_data_home(ordered_data)
						resolve(ordered_data)
					} else {
						// set_loading_message('Nenhuna Informação Cadastrada')
						setLoading('Nenhuna Informação Cadastrada')
						resolve([])
					}
				}).catch((err) => {
					console.error('Error loading clients:', err)
					setLoading('Erro ao carregar clientes')
					reject()
				})
			}
		})
	}



	useEffect(() => {
		loadClients(set_loading_message).then((data) => {
			if (data && data.length > 0) {
				set_data_home(data)
			}
		}).catch((err) => {
			console.error('Error loading clients:', err)
			set_loading_message('Erro ao carregar clientes')
		})
	}, [glpi_level])


	return (
		<div className="flex flexRow height_less_header" style={{ width: "100%" }}>
			{/* <ViteModal /> */}
			<>
				{data_home.length == 0 &&
					<div style={{
						display: "flex",
						flexWrap: "wrap",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						width: "100%"
					}}
						className="height_less_header"
					>
						<div className="flex" style={{ justifyContent: 'center', alignItems: 'center', width: '80%', maxWidth: '80%', height: '20vh', maxHeight: '20vh' }}>
							{loading_message.match(/Carregando/i) && <div className="loader" style={{ width: 50, height: 50, marginRight: 10 }}></div>}
							<h2>{loading_message}</h2>
						</div>

					</div>
				}

				{data_home.length > 0 &&
					<div style={{
						display: "flex",
						flexWrap: "wrap",
						flexDirection: 'row',//profile_data.nivel === 'Cliente' ? "column" : 'row',
						justifyContent: 'flex-start',//profile_data.nivel === 'Cliente' ? "center" : 'flex-start',
						alignItems: 'flex-start',//profile_data.nivel === 'Cliente' ? "center" : 'flex-start',
						width: "100%",
						position: 'relative'
					}}
						className="height_less_header"
					>
						{profile_data.nivel === 'Cliente' &&
							<div className="flex flexWrap height_less_header" style={{
								width: "100%",
								alignItems: "flex-start"
							}}>
								{/* <img style={{ width: '100%' }} src={AvisoHome} /> */}
								<ListTickets />
							</div>
						}

						{(profile_data.nivel.match(/Super|Técnico|Cliente-Admin/i)) &&
							<>
								<div style={{ maxHeight: 50, paddingLeft: 30, paddingRight: 30, marginTop: 20, marginBottom: 10, width: "100%" }} className='flex flex-row items-center justify-between'>
									{profile_data.nivel === 'Cliente-Admin' && <h3>LISTA DE ACESSOS</h3>}
									{(profile_data.nivel.match(/Super|Técnico/i)) && (
										<>
											<h3 styles={{ minWidth: '100%' }}>LISTA DE CLIENTES</h3>
											<div className='flex flex-row items-center'>
												<span className='mr-2'>Exibir clientes inativos</span>
												<input
													onChange={(e) => {
														setShowDisabledCustomers(e.target.checked)
													}}
													checked={showDisabledCustomers}
													type="checkbox"
												/>
											</div>
										</>
									)}
								</div>

								<div className="flex flexWrap height_less_header" style={{ overflowY: "auto", paddingBottom: 70, position: 'relative' }}>
									{data_home.length > 0 && data_home.map((el) => (
										<Card key={el._id} className={styles.card} style={{ width: 180, height: 200 }}>
											<Link
												onClick={() => set_client_details(el)}
												to={{ pathname: 'clientdetails', state: { data_client: el } }}
											// to='clientdetails'
											>
												<CardContent className="flex flexCol justify-content-sb" style={{ height: "100%" }} >
													<img style={{ borderRadius: 5 }} className={styles.imgCard} src={el.logomarca.filename == "" ? `${backend_files_address}/user_placeholder.png` : `${backend_files_address}/${el.logomarca.filename}`} />
													<CardHeader
														style={{ textAlign: "center", padding: 0 }}
														// title={el.nome}
														subheader={el.nome}
													/>
												</CardContent>
											</Link>
										</Card>
									))}
									{showDisabledCustomers &&
										<>
											<hr style={{ marginLeft: 10, marginRight: 10, width: '100%', marginTop: 30, marginBottom: 30, color: '#c3c3c3' }} />

											<h3 style={{ marginLeft: 30, width: '100%' }}>CLIENTES INATIVOS</h3>

											{data_home2.length > 0 && data_home2.map((el) => (
												<Card key={el._id} className={styles.card} style={{ width: 180, height: 200 }}>
													<Link
														onClick={() => set_client_details(el)}
														to={{ pathname: 'clientdetails', state: { data_client: el } }}
													// to='clientdetails'
													>
														<CardContent className="flex flexCol justify-content-sb" style={{ height: "100%" }} >
															<img style={{ borderRadius: 5, opacity: 0.5 }} className={styles.imgCard} src={el.logomarca.filename == "" ? `${backend_files_address}/default-logo.png` : `${backend_files_address}/${el.logomarca.filename}`} />
															<CardHeader
																style={{ textAlign: "center", padding: 0 }}
																// title={el.nome}
																subheader={el.nome}
															/>
														</CardContent>
													</Link>
												</Card>
											))}

											{data_home2.length === 0 &&
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', textAlign: 'center' }}>
													<span style={{ fontSize: '1.2em' }}>Nenhum cliente inativo</span>
												</div>
											}
										</>
									}
								</div>
							</>
						}

						{/* ADICIONAR CLIENTE (CUSTOMER) */}
						{/* {glpi_level.match(/Super|Técnico-Admin/i) && (navigation.page_content === 'home' && window.location.pathname === '/') && */}
					</div>
				}
				{(data_home?.length > 0 || !loading_message.match(/Carregando/i)) && glpi_level?.match(/Super|Técnico-Admin/i) &&
					// <Link to='/cadclient'>
					<Fab
						alt="Adicionar Cliente"
						className="flex center-h center-v"
						onClick={() => {
							setModalData({
								show: true,
								component: <FormDataClient set_data_new_client={() => {
									loadClients(set_loading_message).then((data) => {
										if (data && data.length > 0) {
											set_data_home(data)
										}
										setModalData({
											show: false,
											component: <></>
										})
									}).catch((err) => {
										console.error('Error loading clients:', err)
										set_loading_message('Erro ao carregar clientes')
										setModalData({
											show: false,
											component: <></>
										})
									})
								}} />
								// component: <CadClient />
							})
							// set_content_modal('addcustomer')
							// set_show_modal(true)
						}}
					>
						<span className="material-icons" style={{ fontSize: 33, color: "white", marginLeft: -3 }}>person_add</span>
					</Fab>
					// </Link>
				}
			</>
		</div >

	);
}

export default CustomerList;


